import React from 'react';

import { langs } from './langs';

import type { LocaleType } from '../@types';

export const useTranslations = (locale: LocaleType) => {
  const translations = React.useMemo(() => {
    const defaults = langs.en_us;
    const data = langs[locale.toLowerCase()] || {};

    return {
      ...defaults,
      ...data,
    };
  }, [locale]);

  const t = React.useCallback((key: string) => translations[key] || key, [translations]);

  return [t];
};
